import script from "./selectBot.vue?vue&type=script&setup=true&lang=js"
export * from "./selectBot.vue?vue&type=script&setup=true&lang=js"

import "./selectBot.vue?vue&type=style&index=0&id=2cc3128d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc3128d"]])

export default __exports__